import * as React from 'react';
import { LinkText } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { AuthCard } from './Card';
import { CenteredHeading } from './CentredHeading';
import { CancelIcon } from '@origin-digital/icon';
import { Page } from './Page';
import { ErrorViewContent } from '../passwordless-login/components/pages/error/ErrorViewContent';
import { MarkdownLite, Text } from '@origin-digital/ods-core';

interface ErrorViewProps {
  authenticated?: boolean;
  errorMessage: string;
  title: string;
  linkProps: LinkProps;
}

interface LinkProps {
  linkHref: string;
  onLinkClicked?: () => void;
  linkText?: string;
}

const ErrorView: React.FC<ErrorViewProps> = ({
  authenticated = false,
  errorMessage,
  title,
  linkProps: { linkHref, linkText = 'Go Back', onLinkClicked },
}) => (
  <Page authenticated={authenticated}>
    <AuthCard>
      <ErrorViewContent>
        <Box marginBottom={6}>
          <CancelIcon data-id="error-icon" color={'redPink'} size={40} />
        </Box>
        <Box marginBottom={4}>
          <CenteredHeading data-id="error-title" text={title} />
        </Box>
        <Box marginBottom={6}>
          <Text align="center" data-id="error-msg">
            <MarkdownLite>{errorMessage}</MarkdownLite>
          </Text>
        </Box>
        <Box alignContent="center">
          <LinkText
            color="red"
            data-id="error-back-button"
            onClick={onLinkClicked}
            href={linkHref}
            text={linkText}
          />
        </Box>
      </ErrorViewContent>
    </AuthCard>
  </Page>
);

export { ErrorView };
